import React from 'react'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { Grid, TextField } from '@mui/material'
import BasicSelect from './BasicSelect'
import { getError } from './event'
import { prefixOptions } from '../constant'
import { setEnrollDetail } from 'src/redux/slices/eLearning/enroll'

const TitleInput = ({
  index,
  obj,
  isDisabled = false,
  sm = 6,
  md = 'unset',
  required = true,
}) => {
  const dispatch = useDispatch()
  const { value, formError } = useSelector(
    (state) => ({
      value: state.eLearningEnroll.body.enroll[index][obj],
      formError: state.eLearningEnroll.formError[index],
    }),
    shallowEqual
  )
  return (
    <Grid item md={md} sm={sm} xs={12}>
      <BasicSelect
        sx={{
          '& .MuiAutocomplete-inputRoot': {
            pl: 1,
            height: 50,
            background: '#FFFFFF',
          },
        }}
        labelText="คำนำหน้าชื่อ"
        required={required}
        ShowTextError={getError(formError, 'prefixTH')}
        textError={getError(formError, 'prefixTH')}
        options={prefixOptions}
        getOptionLabel={(option) => option.label}
        handleChange={(e) =>
          dispatch(
            setEnrollDetail({
              key: 'enroll',
              index,
              obj,
              value: e.target.value,
            })
          )
        }
        handleInputChange={(e, value) =>
          dispatch(
            dispatch(
              setEnrollDetail({
                key: 'enroll',
                index: index,
                obj: obj,
                value: value,
              })
            )
          )
        }
        inputValue={value || ''}
        renderInput={(params) => (
          <TextField {...params} placeholder="กรุณาเลือก" />
        )}
        isHideSort={true}
        noOptionsText={'กรุณาเลือกคำนำหน้าชื่อ'}
        disabled={isDisabled}
      />
    </Grid>
  )
}

export default TitleInput
